<div class="panel">
  <div class="panel-title">
    <h3 class="title">{{ 'agent:contact.workspace.phone.script_redirect.title' | translate }}</h3>
  </div>
  <div id="scriptAnchorForm" *ngIf="!isScriptRedirecting && displayAnchorsForCsrRelease" class="panel-body">
    <p *ngIf="displayAnchorsForCsrRelease">
      <label for="csrReleaseTypeSelect">{{ 'agent:contact.workspace.phone.script_redirect.prefix' | translate }}</label>
      <select
        id="csrReleaseTypeSelect"
        [(ngModel)]="scriptRedirect.target"
        *ngIf="scriptRedirect.type === getCsrReleaseType()"
        (change)="updateScriptRedirect()"
      >
        <option *ngFor="let anchor of availableAnchorsForCsrRelease" [ngValue]="anchor">{{ anchorLabel(anchor) }}</option>
      </select>
      <label for="csrReleaseTypeSelect">{{ 'agent:contact.workspace.phone.script_redirect.with_csr_release' | translate }}</label>
    </p>
  </div>
  <div *ngIf="availableAnchorsForCsrRelease.length === 0">
    {{ 'agent:contact.workspace.phone.script_redirect.no_anchor_available' | translate }}
  </div>
  <div *ngIf="isScriptRedirecting && !scriptRedirect.done" class="panel-body center">
    <span *ngIf="scriptRedirect.target.type === getCsrReleaseType()">{{
      'agent:contact.workspace.phone.script_redirect.dialing' | translate
    }}</span>
  </div>
  <div *ngIf="!isScriptRedirecting && scriptRedirect.done" class="panel-body center">
    {{ 'agent:contact.workspace.phone.script_redirect.done' | translate }}
  </div>
</div>
